import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

export default function DraftShipmentModal({
  onClose,
  onKeepAsDraft,
  onMarkAsReceived,
  description,
  cancelLabel = "Keep as Draft",
  confirmLabel = "Yes, Received",
}) {
  return (
    <Dialog open maxWidth="xs" fullWidth>
      <DialogTitle sx={{ position: "relative" }}>
        <Box display="flex" alignItems="center" justifyContent="center" position="relative">
          <Typography fontSize={24} fontWeight={500} color="text.secondary" align="center">
            Attention
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography fontSize={16} align="center" sx={{ mb: 2 }}>
          {description}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, justifyContent: "center", gap: 2 }}>
        <Button onClick={onKeepAsDraft} variant="outlined" sx={{ minWidth: 150 }}>
          {cancelLabel}
        </Button>
        <Button
          onClick={onMarkAsReceived}
          variant="contained"
          color="primary"
          sx={{ minWidth: 150 }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
